/* eslint-disable no-debugger */
import { isValidElement } from 'react';
import { omitBy, isUndefined } from 'lodash';
import { disableBodyScroll, enableBodyScroll } from '@src/util/toggleBodyScroll';

export const MODAL_CLOSED = `${__dirname}/modalClosed`;
export function closeModal() {
  enableBodyScroll();

  return { type: MODAL_CLOSED };
}

export const MODAL_CONFIG_CHANGED = `${__dirname}/modalConfigChanged`;
export function changeModalConfig(config) {
  return {
    config: omitBy(
      {
        disableClose: config.disableClose,
        hideCloseButton: config.hideCloseButton,
        shouldCloseOnEsc: config.shouldCloseOnEsc,
        shouldCloseOnOverlayClick: config.shouldCloseOnOverlayClick,
        withoutPadding: config.withoutPadding,
      },
      isUndefined,
    ),
    type: MODAL_CONFIG_CHANGED,
  };
}

export const MODAL_CONTENT_SET = `${__dirname}/modalContentSet`;
export function setModalContent(data) {
  disableBodyScroll();

  if (isValidElement(data)) {
    return {
      content: data,
      type: MODAL_CONTENT_SET,
    };
  }

  const config = data.config || {};

  return {
    className: data.className || '',
    closeButton: data.closeButton,
    config: {
      disableClose: config.disableClose,
      hideCloseButton: config.hideCloseButton,
      shouldCloseOnEsc: config.shouldCloseOnEsc,
      shouldCloseOnOverlayClick: config.shouldCloseOnOverlayClick,
      withoutPadding: config.withoutPadding,
    },
    content: data.content,
    currentStackKey: data.currentStackKey,
    doNotCloseOnLocationChange: !!data.doNotCloseOnLocationChange,
    onClose: data.onClose,
    shouldNotCloseOnLocationReplace: !!data.shouldNotCloseOnLocationReplace,
    stack: data.stack ? data.stack.map(view => ({ ...view, config: view.config || {} })) : [],
    title: data.title,
    type: MODAL_CONTENT_SET,
  };
}
